<template>
  <div id="printPDF">
    <div class="modal-content" >
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">PHIẾU THANH TOÁN CĂN HỘ {{apartment_data.apartment_code}}</h4>
        <div class="col-md-12">
          <div class="form-group">
            <div
              class="radio custom-control-inline"
              v-for="(option, index) in radioReturnTypeOptions"
              :key="index"
            >
              <label>
                <input
                  type="radio"
                  :value="option.value"
                  :disabled="option.disable"
                  name="radioReturnTypeOptions"
                  v-model="bookingPaymentData.returnType"
                  @change="onChangeReturnType"
                />
                {{option.text}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-user"></i> <strong>Khách Hàng</strong>
                </h2>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="col-xs-6">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody><tr>
                      <th style="width:50%">Khách Hàng:</th>
                      <td>{{bookingData.booking_person_name}}</td>
                    </tr>
                    <tr>
                      <th>{{$t('apartmentbookings.checkin_datetime')}}:</th>
                      <td v-if="bookingPaymentData.returnType === 1">{{formatDate(bookingData.checkin_datetime)}}</td>
                      <td v-else-if="bookingPaymentData.returnType === 2">{{formatDate(bookingPaymentData.payment_checkin)}}</td>
                    </tr>
                    <tr>
                      <th>Số Phòng Ngủ:</th>
                      <td>1</td>
                    </tr>
                    <!-- // #1131 Thếm Số Ngày -->
                    <tr>
                      <th>Số Ngày:</th>
                      <td v-if="bookingPaymentData.returnType === 1">{{bookingData.duration}} {{$t('common.day')}}</td>
                      <td v-else-if="bookingPaymentData.returnType === 2">{{bookingPaymentData.duration}} {{$t('common.day')}}</td>
                    </tr>

                    <!-- [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN -->
                    <tr>
                      <th>{{$t('customer.info_invoice.profile_company_name')}}:</th>
                      <td>{{bookingData.company_name}}</td>
                    </tr>
                    <tr>
                      <th>{{$t('customer.info_invoice.profile_company_address')}}:</th>
                      <td>{{bookingData.company_address}}</td>
                    </tr>

                  </tbody></table>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody><tr>
                      <th style="width:50%">Mã HĐ:</th>
                      <td>
                        <span v-if="bookingPaymentData.payment_code">{{bookingPaymentData.payment_code}}</span>
                        <span v-else><i style="color:red;">Tự Động Tạo</i></span>
                      </td>
                    </tr>
                    <tr>
                      <th>{{$t('apartmentbookings.checkout_datetime')}}:</th>
                      <td v-if="bookingPaymentData.returnType === 1">{{formatDate(bookingData.checkout_datetime)}}</td>
                      <td v-else-if="bookingPaymentData.returnType === 2">{{formatDate(bookingPaymentData.payment_checkout)}}</td>
                    </tr>
                    <tr>
                      <th>{{$t('apartmentbookings.booking_room_rate')}}:</th>
                      <td>{{formatNumber(bookingData.apartment_map_booking.booking_room_rate_daily)}}</td>
                    </tr>
                    <tr>
                      <th>{{$t('apartmentbookings.sale_off')}}:</th>
                      <td>{{formatNumber(bookingData.sale_off)}}%</td>
                    </tr>

                    <!-- [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN -->
                    <tr>
                      <th>{{$t('customer.info_invoice.profile_company_tax_code')}}:</th>
                      <td>{{bookingData.company_tax_code}}</td>
                    </tr>
                    <tr>
                      <th>{{$t('customer.info_invoice.profile_company_email')}}:</th>
                      <td>{{bookingData.company_email}}</td>
                    </tr>
                    <!-- <tr>
                      <th>Thuế:</th>
                      <td>{{bookingData.apartment_map_booking.booking_room_rate_vat}}%</td>
                    </tr> -->
                  </tbody></table>
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <hr>
            </div>
          </div>
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-dollar "></i> <strong>{{$t('apartmentbookings.apartment_rental')}}</strong>
                </h2>
              </div>
              <div class="col-xs-12" v-if="bookingPaymentData.returnType === 1">
                <div>
                  <strong>Tiền Trước Thuế:</strong>
                  {{formatNumber(bookingPaymentData.room_rates.total)}}
                </div>
                <div>
                  <strong>Tiền Thuế:</strong>
                  {{formatNumber(bookingPaymentData.room_rates.tax)}}
                </div>
                <div>
                  <strong>Tiền Sau Thuế:</strong>
                  {{formatNumber(bookingPaymentData.room_rates.total_with_tax)}}
                </div>
              </div>
              <div class="col-xs-12" v-else-if="bookingPaymentData.returnType === 2">
                <div>
                  <strong>Tiền Trước Thuế:</strong>
                  {{formatNumber(bookingPaymentData.room_rates.realTotal)}}
                </div>
                <div>
                  <strong>Tiền Thuế:</strong>
                  {{formatNumber(bookingPaymentData.room_rates.realTax)}}
                </div>
                <div>
                  <strong>Tiền Sau Thuế:</strong>
                  {{formatNumber(bookingPaymentData.room_rates.real_total_with_tax)}}
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="col-xs-6">
              </div>
              <div class="col-xs-6">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody><tr>
                      <th style="width:50%">{{$t('apartmentbookings.room_rental_factor')}}:</th>
                      <td><b-form-select
                        v-model="bookingPaymentData.room_payment_factor"
                        :options="paymentDurationFactor"
                        class="form-control"
                        disabled
                      /></td>
                    </tr>
                  </tbody></table>
                </div>
              </div>
              <!-- Temporary hide -->
              <div class="col-xs-12" v-if="bookingPaymentData.returnType === 1">
                <div class="col-xs-12 table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.no')}}</th>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.from_dt')}}</th>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.to_dt')}}</th>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.days')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.price')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.discount')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.price_after_adjust')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.tax')}} ({{bookingData.apartment_map_booking.booking_room_rate_vat}}%)</th>
                        <th class="text-right">{{$t('apartmentbookings.paymentBooking.total_price')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in bookingPaymentData.room_rates.periods" :key="index">
                        <td class="text-center">{{index + 1}}</td>
                        <td class="text-center">{{item.start}}</td>
                        <td class="text-center">{{item.end}}</td>
                        <td class="text-center">{{item.days}}</td>
                        <td class="text-right">{{formatNumber(item.price)}}</td>
                        <td class="text-right">{{formatNumber(item.discount)}}</td>
                        <td class="text-right">{{formatNumber(item.price - item.discount)}}</td>
                        <td class="text-right">{{formatNumber(item.price_with_tax)}}</td>
                        <td class="text-right">{{formatNumber(item.price - item.discount + item.price_with_tax)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Calculator some fee by number of days in real -->
              <div class="col-xs-12" v-else-if="bookingPaymentData.returnType === 2">
                <div class="col-xs-12 table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.no')}}</th>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.from_dt')}}</th>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.to_dt')}}</th>
                        <th class="text-center">{{$t('apartmentbookings.room_rates.days')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.price')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.discount')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.price_after_adjust')}}</th>
                        <th class="text-right">{{$t('apartmentbookings.room_rates.tax')}} ({{bookingData.apartment_map_booking.booking_room_rate_vat}}%)</th>
                        <th class="text-right">{{$t('apartmentbookings.paymentBooking.total_price')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in bookingPaymentData.room_rates.periods" :key="index">
                        <td class="text-center">{{index + 1}}</td>
                        <td class="text-center">{{item.start}}</td>
                        <td class="text-center">{{item.realEnd}}</td>
                        <td class="text-center">{{item.realDays}}</td>
                        <td class="text-right">{{formatNumber(item.realPrice)}}</td>
                        <td class="text-right">{{formatNumber(item.discount)}}</td>
                        <td class="text-right">{{formatNumber(item.realPrice - item.discount)}}</td>
                        <td class="text-right">{{formatNumber(item.real_price_with_tax)}}</td>
                        <td class="text-right">{{formatNumber(item.realPrice - item.discount + item.real_price_with_tax)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <hr>
            </div>
          </div>
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-certificate "></i> <strong>{{$t('apartmentbookings.e_w')}}</strong>
                </h2>
              </div>
              <div class="col-xs-12">
                <div>
                  <strong>Tiền Trước Thuế:</strong>
                  {{formatNumber(bookingPaymentData.basic_services_rates.total)}}
                </div>
                <div>
                  <strong>Tiền Thuế:</strong>
                  {{formatNumber(bookingPaymentData.basic_services_rates.tax)}}
                </div>
                <div>
                  <strong>Tiền Sau Thuế:</strong>
                  {{formatNumber(bookingPaymentData.basic_services_rates.total_with_tax)}}
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="col-xs-6">
              </div>
              <div class="col-xs-6">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th style="width:50%">{{$t('apartmentbookings.booking_service_information.ew_included')}}:</th>
                        <td><input
                          v-model="bookingPaymentData.ew_included"
                          style="width: 15px; height: 15px;"
                          class="control-label"
                          type="checkbox"
                          @change="onChangeBasicService()"
                        ></td>
                      </tr>
                  </tbody></table>
                </div>
              </div>
              <div v-if="!bookingPaymentData.ew_included">
                <div class="col-xs-6">
                </div>
                <div class="col-xs-6">
                  <div class="table-responsive customer-info">
                    <table class="table">
                      <tbody>
                        <tr>
                          <th style="width:50%">{{$t('apartmentbookings.start_e')}}:</th>
                          <td>{{bookingData.start_e}} kWh</td>
                        </tr>
                        <tr>
                          <th style="width:50%">{{$t('apartmentbookings.start_w')}}:</th>
                          <td>{{bookingData.start_w}} m³</td>
                        </tr>
                    </tbody></table>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="col-xs-12">
                    <div class="table-responsive customer-info">
                      <table class="table">
                        <tbody>
                          <tr>
                            <th style="width:12%">{{$t('apartmentbookings.services')}}:</th>
                            <td style="width:15%"><select
                              class="form-control"
                              style="width:60%"
                              v-model="basicServices.selectedService"
                            >
                              <option
                                v-for="option in basicServices.options"
                                v-bind:value="option.value"
                                :key="option.value"
                              >{{ $t(`apartmentbookings.service_names.${option.text}`) }}</option>
                            </select></td>
                            <td style="width:25%"><button
                              class="btn btn-info"
                              @click="onAddBasicService()"
                            >
                              <i class="glyphicon glyphicon-plus"></i>
                              {{ $t(`common.add`) }}
                            </button></td>
                          </tr>
                      </tbody></table>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="col-xs-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>{{$t('common.nonumber')}}</th>
                          <th>{{$t('apartmentbookings.basicService.service')}}</th>
                          <th style="width: 15%;">{{$t('apartmentbookings.basicService.day')}}</th>
                          <th style="width: 10%;">{{$t('apartmentbookings.basicService.index')}}</th>
                          <th>{{$t('apartmentbookings.basicService.consumption')}}</th>
                          <th style="width: 12%;">{{$t('apartmentbookings.basicService.unit_price')}}</th>
                          <th class="text-right">Phí</th>
                          <th style="width: 12%;">Thuế (%)</th>
                          <th class="text-right">T.Thuế</th>
                          <th class="text-right">{{$t('apartmentbookings.paymentBooking.total_price')}}</th>
                          <th class="text-center">{{$t('apartmentbookings.basicService.action')}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for=" (item, index) in bookingPaymentData.basic_services_rates.periods" :key="index">
                          <td>{{index + 1}}</td>
                          <td>{{$t(`apartmentbookings.service_names.${item.service.name}`)}}</td>
                          <td><date-picker class="form-control basic-input" v-model="item.until_date" :config="options"></date-picker></td>
                          <td><input type="number" :min="item.old_index.value" class="form-control basic-input" v-model="item.new_index.value" @change="onChangeNewIndex(item)" v-on:keyup="onChangeNewIndex(item)" :disabled="item.new_index.disable"></td>
                          <td class="text-center">{{item.consumption}}</td>
                          <td><input class="form-control basic-input" v-model="item.unit_price" @change="onChangeUnitPrice(item)" v-on:keyup="onChangeUnitPrice(item)"></td>
                          <td class="text-center">{{formatNumber(item.price)}}</td>
                          <!-- Thuế -->
                          <td><input type="number" class="form-control basic-input" min="0" max="100" v-model="item.vat" @change="onChangeVat(item)" v-on:keyup="onChangeVat(item)"></td>
                          <!-- Tax -->
                          <td class="text-right">{{formatNumber(item.tax)}}</td>
                          <td class="text-right">{{formatNumber(item.price + item.tax)}}</td>
                          <td class="text-center"><button v-if="item.removable" type="button" class="btn btn-sm btn-warning" @click="onRemoveBasicServices(item, index)"><i class="fa fa-trash"></i></button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <hr>
              </div>
            </div>
          </div>
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-edit "></i> <strong>{{$t('apartmentbookings.otherService.title')}}</strong>
                </h2>
              </div>
              <div class="col-xs-6">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th style="width:50%">{{$t('apartmentbookings.otherService.extra')}} Trước Thuế:</th>
                        <td><input
                          class="form-control basic-input"
                          type="text"
                          v-model="bookingPaymentData.payment_other_fee"
                          @change="onChangeTotal()"
                          v-on:keyup="onChangeTotal()"
                        ></td>
                      </tr>
                      <!-- VAT -->
                      <tr>
                        <th style="width:50%">Thuế (%):</th>
                        <td><input
                          style="width: 30%;"
                          class="form-control basic-input"
                          type="number"
                          v-model="bookingPaymentData.payment_other_vat"
                          @change="onChangeTotal()"
                          v-on:keyup="onChangeTotal()"
                        ></td>
                      </tr>
                      <!-- TAX -->
                      <tr>
                        <th style="width:50%">Thuế GTGT (VND):</th>
                        <td><input
                          disabled
                          class="form-control basic-input"
                          type="text"
                          v-model="bookingPaymentData.payment_other_tax"
                        ></td>
                      </tr>
                      <!-- Total with tax -->
                      <tr>
                        <th style="width:50%">Tổng Tiền Sau Thuế:</th>
                        <td><input
                          disabled
                          class="form-control basic-input"
                          type="text"
                          v-model="bookingPaymentData.payment_other_fee_with_tax"
                        ></td>
                      </tr>
                  </tbody></table>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th style="width:50%">{{$t('apartmentbookings.otherService.discount')}}:</th>
                        <td><input
                          class="form-control basic-input"
                          type="text"
                          v-model="bookingPaymentData.discount"
                          @change="onChangeTotal()"
                          v-on:keyup="onChangeTotal()"
                        ></td>
                      </tr>
                  </tbody></table>
                </div>
              </div>
              <div class="col-xs-12">
                <hr>
              </div>
            </div>
          </div>
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-calculator "></i> <strong>{{$t('apartmentbookings.paymentBooking.title')}}</strong>
                </h2>
              </div>
              <div class="col-xs-12">
                <div>
                  <strong>Tiền Đặt Cọc:</strong>
                  {{formatNumber(bookingData.deposit)}}
                </div>
                <div>
                  <strong>Tiền Trả Trước:</strong>
                  {{formatNumber(bookingData.payment_in_advance)}}
                </div>
                <div>
                  <strong>Tiền Trước Thuế:</strong>
                  {{formatNumber(bookingPaymentData.payment_amount)}}
                </div>
                <div>
                  <strong>Tiền Thuế:</strong>
                  {{formatNumber(bookingPaymentData.payment_amount_tax)}}
                </div>
                <div>
                  <strong>Tiền Sau Thuế:</strong>
                  {{formatNumber(bookingPaymentData.payment_amount_with_tax)}}
                </div>
                <div>
                  <hr style="width: 40%; margin-left: inherit;">
                </div>
                <div>
                  <strong>Tổng Số Tiền Cần Thanh Toán:</strong>
                  {{view_total_paid}}
                </div>
                <div>
                  <strong>Tiền Hoàn Trả:</strong>
                  {{view_total_return}}
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="col-xs-6">
              </div>
              <div class="col-xs-6">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th style="width:50%">{{$t('apartmentbookings.paymentBooking.status')}}:</th>
                        <td>
                          <select class="form-control select2" style="width: 100%;" v-model="bookingPaymentData.status">
                            <option
                              v-for="(option, index) in bookingPaymentStatus"
                              v-bind:value="option.id"
                              :key="index"
                            >{{ $t(`apartmentbookings.paymentBooking.statusList.${option.name}`) }}</option>
                          </select>
                        </td>
                      </tr>
                      <!-- Payment Type -->
                      <tr>
                        <th style="width:50%;">Hình Thức Thanh Toán:</th>
                        <td style="padding-top: 5px;">
                          <select class="form-control select2" style="width: 100%;" v-model="bookingPaymentData.type">
                            <option
                              v-for="(option, index) in bookingPaymentTypes"
                              v-bind:value="option.id"
                              :key="index"
                            >{{ $t(option.text) }}</option>
                          </select>
                        </td>
                      </tr>
                      <!-- Deposit Option -->
                      <tr>
                        <th style="width:50%;">Cấn Trừ Tiền Cọc:</th>
                        <td style="padding-top: 5px;">
                          <select class="form-control select2" style="width: 100%;" v-model="bookingPaymentData.deposit_option">
                            <option
                              v-for="(option, index) in bookingDepositOptions"
                              v-bind:value="option.id"
                              :key="index"
                            >{{ $t(option.text) }}</option>
                          </select>
                        </td>
                      </tr>
                      <!-- Export Option -->
                      <tr>
                        <th style="width:50%;">Trạng Thái Hóa Đơn:</th>
                        <td style="padding-top: 5px;">
                          <select class="form-control select2" style="width: 100%;" v-model="bookingPaymentData.payment_export_option">
                            <option
                              v-for="(option, index) in bookingExportOptions"
                              v-bind:value="option.id"
                              :key="index"
                            >{{ $t(option.text) }}</option>
                          </select>
                        </td>
                      </tr>
                  </tbody></table>
                </div>
              </div>
              <div class="col-xs-12">
                <div class="table-responsive customer-info">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th style="width:23%">{{$t('apartmentbookings.paymentBooking.other_details')}}:</th>
                        <td><textarea
                          class="form-control"
                          rows="5"
                          v-model="bookingPaymentData.payment_other_details"
                        ></textarea></td>
                      </tr>
                      <tr v-if="bookingPaymentData.id !== 0">
                        <th style="width:23%">{{$t('apartmentbookings.paymentBooking.user_created')}}:</th>
                        <td>{{user_created}}</td>
                      </tr>
                  </tbody></table>
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </div>
      <div class="modal-footer" id="print-pdf-footer">
        <button
          style="background-color: #f29911;border-color: #f29911;color:#fff"
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.back')}}</button>
        <button
          type="button"
          class="btn btn-primary btn-green"
          @click="onPrintPdf"
        >{{$t('common.printPdf')}}</button>
        <button
          v-if="bookingPaymentData.id !== 0"
          type="button"
          class="btn btn-primary btn-green"
          @click="onSave"
        >{{$t('common.save')}}</button>
        <!-- <button
          v-if="bookingPaymentData.id === 0"
          type="button"
          class="btn btn-primary btn-green"
          @click="onAdd"
        >{{$t('common.add')}}</button> -->
        <button
          v-if="bookingPaymentData.id === 0"
          type="button"
          class="btn btn-primary btn-green"
          @click="onShowModalConfirmCheckout"
        >{{$t('common.checkout')}}</button>
      </div>
      <!-- /.modal-content -->
      <div class="modal fade" id="modal-confirm" ref="modal-confirm">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title">{{$t('apartment.reservations.checkout')}}</h1>
            </div>
            <div class="modal-body">
              <b-form>
                <b-form-group label-size="sm" label-for="input-sm" :label="$t('apartment.reservations.confirm_sure_checkout') + '?'"> 
                </b-form-group>
              </b-form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary btn-sm pull-right"
                @click="onCheckOut(bookingData.id)"
              >{{$t('common.delete_modal.btnYes')}}</button>
              <button
                type="button"
                class='btn btn-warning btn-sm pull-left'
                @click="onHideModalCheckout()"
              >{{$t('common.back')}}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>    
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
// import LTEModal from "@/components/LTEModal.vue";
// import LTECoreAlert from "@/components/LTESnackBar.vue";
// import Paginator from "@/components/Paginator.vue";
// import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
// import booking from "@/components/LTEBooking";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
// import LTEModalBookingDetail from "@/components/LTEModalBookingDetail";
// import LeaseBackApartmentInputView from "./LeaseBackApartmentInputView"
// import LeaseBackTenantBooking from "./LeaseBackTenantBooking"
import constants from "../../lib/constantsData"
import ExportStatusEnum from "@/enum/exportStatusEnum";

export default {
  name: "LeaseBackBookingPayment",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    checkout_show: {
      type: Boolean,
      default: () => {return true}
    }
  },
  data () {
    return {
      apartment_id: 0,
      apartment_data: {
        apartment_code: null
      },
      bookingData: {
        id: 0,
        checkin_datetime: null,
        checkout_datetime: null,
        // #1131 Thếm Số Ngày
        duration: "",
        booking_person_name: "",

        apartment_map_booking: {
          booking_room_rate: 0,
          booking_room_rate_daily: 0,
          booking_room_rate_vat: 0,
          other_fee: 0,
          other_details: null,
          other_vat: 0,
          payment_duration_factor: 1
        },
        sale_off: 0,
        discount: 0,
        ew_included: false,
        start_e: 1471,
        start_w: 11,
        services_booking: [],
        booking_payment: 0,
        deposit: 0,
        payment_in_advance: 0,

        // [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN
        company_name: "",
        company_address: "",
        company_tax_code: "",
        company_email: ""
      },
      bookingPaymentData: {
        id: 0,
        apt_booking: 0,
        apartment: 0,
        payment_code: null,
        payment_amount: 0,
        payment_amount_tax: 0,
        payment_amount_with_tax: 0,
        payment_left_amount: 0,
        payment_date: null,
        payment_other_details: null,
        payment_other_fee: 0,
        payment_other_vat: 0,
        payment_other_tax: 0,
        payment_other_fee_with_tax: 0,
        returnType: 1,
        payment_checkout: null,
        payment_checkin: null,
        duration: 0,
        room_payment_factor: 1,
        ew_included: false,
        discount: 0,
        status: 2,
        type: 1,
        deposit_option: true,
        payment_export_option: ExportStatusEnum.NOT_EXPORT,
        room_rates: {
          total: 0,
          periods: [],
          real_periods: [],
          tax: 0,
          total_with_tax: 0
        },
        basic_services_rates: {
          total: 0,
          periods: [],
          tax: 0,
          total_with_tax: 0
        },
        services_booking: []
      },
      paymentDurationFactor: constants.paymentDurationFactor,
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        //maxDate: moment().subtract(2, "days"),
      },
      basicServices: {
        selectedService: 1,
        options: constants.basicServices
      },
      bookingPaymentStatus: constants.paymentStatusText,
      bookingPaymentTypes: constants.paymentsType,
      bookingDepositOptions: constants.depositOptionsText,
      bookingExportOptions: constants.exportStatusText,
      user_created: null,
      e_unit_price: 0,
      w_unit_price: 0,
    }
  },
  watch: {
    item: function () {
      this.create()
    }
  },
  computed: {
    ...mapGetters([
    ]),
    radioReturnTypeOptions: function() {
      let today_m = {
        day: moment().date(),
        month: moment().month(),
        year: moment().year()
      }
      let checkout_datetime_m = {
        day: moment(this.bookingData.checkout_datetime).date(),
        month: moment(this.bookingData.checkout_datetime).month(),
        year: moment(this.bookingData.checkout_datetime).year()
      }
      today_m = moment([today_m.year, today_m.month, today_m.day])
      checkout_datetime_m = moment([checkout_datetime_m.year, checkout_datetime_m.month, checkout_datetime_m.day])
      if (today_m.diff(checkout_datetime_m, 'days') >= 0 ) {
        return [
          {
            value: 1,
            text: "Thanh toán theo ngày dự kiến trả phòng",
            disable: false
          },
          {
            value: 2,
            text: "Thanh toán theo ngày hiện tại",
            disable: true
          }
        ]
      }
      return [
        {
          value: 1,
          text: "Thanh toán theo ngày dự kiến trả phòng",
          disable: false
        },
        {
          value: 2,
          text: "Thanh toán theo ngày hiện tại",
          disable: false
        }
      ]
    },
    final_total_paid: function(){
      let amount
      if (this.bookingPaymentData.deposit_option === 1) {
        amount = this.formatNumber(this.bookingPaymentData.payment_amount_with_tax - this.bookingData.payment_in_advance - this.bookingData.deposit)
      } else {
        amount = this.formatNumber(this.bookingPaymentData.payment_amount_with_tax - this.bookingData.payment_in_advance)
      }
      
      return amount
    },
    final_total_return: function(){
      let amount
      if (this.bookingPaymentData.deposit_option === 1) {
        amount = 0
      } else {
        amount = this.formatNumber(this.bookingData.deposit)
      }
      return amount
    },
    view_total_paid: function() {
      if (parseInt(utils.formatInteger(this.final_total_paid.toString())) >= 0 ){
        return this.final_total_paid
      } else {
        return 0
      }
    },
    view_total_return: function() {
      let ret = parseInt(utils.formatInteger(this.final_total_return.toString()))
      if (parseInt(utils.formatInteger(this.final_total_paid.toString())) < 0 ){
        ret = ret + Math.abs(parseInt(utils.formatInteger(this.final_total_paid.toString())))
      }
      return this.formatNumber(ret)
    }
  },
  methods: {
    // change return type
    onChangeReturnType: function(){
      this.setTotalBookingPayment()
    },
    // #1131 Thếm Số Ngày
    getDaysDiff: function(date2, date1, include_start=true){
      let date2_m = {
        day: moment(date2).date(),
        month: moment(date2).month(),
        year: moment(date2).year()
      }
      let date1_m = {
        day: moment(date1).date(),
        month: moment(date1).month(),
        year: moment(date1).year()
      }
      date2_m = moment([date2_m.year, date2_m.month, date2_m.day])
      date1_m = moment([date1_m.year, date1_m.month, date1_m.day])
      if (include_start){
        return date2_m.diff(date1_m, 'days') + 1
      }
      if (date2_m.isSame(date1_m)) {
        return 1
      }
      return date2_m.diff(date1_m, 'days')
    },
    onHideModalCheckout: function() {
      $(this.$refs['modal-confirm']).modal("hide");
    },
    onShowModalConfirmCheckout: function() {
      $(this.$refs['modal-confirm']).modal("show");
    },
    onPrintPdf: function(){
      let routeData = this.$router.resolve({
          name: "LeaseBackBookingPaymentPdf",
          query: this.item
      });
      window.open(routeData.href, "_blank");
    },
    //
    // print pdf from modal
    // Author: loitt
    // 
    printElement(id) {
      // get modal current by id
      const modal = document.getElementById(id)
      const cloned = modal.cloneNode(true)
      let section = document.getElementById("printSection")

      if (!section) {
        section  = document.createElement("div")
        section.id = "printSection"
        document.body.appendChild(section)
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
      document.getElementById("printSection").remove();
    },

    validateBasicFee: function(){
      alert("Cần Nhập Đơn Giá Điện, Nước");
    },

    onSave: function(event, checkout_evt = false) {
      if (!utils.isNull(event)) {
        event.preventDefault();
      }
      let room_rates = []
      let room_rates_data = this.bookingPaymentData.room_rates.periods
      room_rates_data.forEach(v => {
        let realEnd = moment(v.realEnd, 'DD-MM-YYYY')
        realEnd.set({hour:0,minute:0,second:0,millisecond:0})
        let end = moment(v.end, 'DD-MM-YYYY')
        end.set({hour:0,minute:0,second:0,millisecond:0})
        let start = moment(v.start, 'DD-MM-YYYY')
        start.set({hour:0,minute:0,second:0,millisecond:0})
        let item = {
          days: v.days,
          realDays: v.realDays,
          discount: v.discount,
          end: end,
          realEnd: realEnd,
          start: start,
          price: v.price,
          status: 1
        }
        room_rates.push(item)
      })

      let check_basic_services_ok = true
      let basic_services_rates = []
      let basic_services_rates_data = this.bookingPaymentData.basic_services_rates.periods
      basic_services_rates_data.forEach(v => {
        if ((v.unit_price == 0) || (v.unit_price == null)) {
          check_basic_services_ok = false
        }
        let end = moment(v.until_date, 'DD-MM-YYYY')
        end.set({hour:0,minute:0,second:0,millisecond:0})
        let item = {
          service: v.service.id,
          old_index: v.old_index.value,
          new_index: v.new_index.value,
          unit_price: utils.formatInteger(v.unit_price.toString()),
          status: 1,
          disable: v.new_index.disable,
          vat: v.vat,
          tax: v.tax,
          removable: v.removable,
          end: end
        }
        basic_services_rates.push(item)
      })

      if (check_basic_services_ok === false) {
        this.validateBasicFee()
        //this.$emit("onClose")
        return
      }
      
      const saveBookingPayment = {
        apt_booking: this.bookingPaymentData.apt_booking,
        apartment: this.apartment_id,
        payment_code: this.bookingPaymentData.payment_code,
        payment_amount: this.bookingPaymentData.payment_amount,
        payment_amount_vat: this.bookingPaymentData.payment_amount_tax,
        payment_amount_after_vat: this.bookingPaymentData.payment_amount_with_tax,
        payment_left_amount: this.bookingPaymentData.payment_left_amount,
        payment_date: null,
        payment_other_details: this.bookingPaymentData.payment_other_details,
        payment_other_fee: utils.formatInteger(this.bookingPaymentData.payment_other_fee.toString()),
        payment_other_fee_vat: this.bookingPaymentData.payment_other_vat,
        room_payment_factor: this.bookingPaymentData.room_payment_factor,
        ew_included: this.bookingPaymentData.ew_included,
        discount: utils.formatInteger(this.bookingPaymentData.discount.toString()),
        status: this.bookingPaymentData.status,
        payment_type: this.bookingPaymentData.type,
        room_rates: room_rates,
        basic_services_rates: basic_services_rates,
        services_booking: this.bookingPaymentData.services_booking,
        payment_deposit_option: this.bookingPaymentData.deposit_option,
        payment_export_option: this.bookingPaymentData.payment_export_option,
        return_type: this.bookingPaymentData.returnType,
        payment_checkin:this.bookingPaymentData.payment_checkin,
        payment_checkout: this.bookingPaymentData.payment_checkout
      }
      this.$emit("onSave", this.bookingPaymentData.id, saveBookingPayment, checkout_evt)
    },
    onAdd: function(event, checkout_evt = false) {
      if (!utils.isNull(event)) {
        event.preventDefault();
      }
      let room_rates = []
      let room_rates_data = this.bookingPaymentData.room_rates.periods
      room_rates_data.forEach(v => {
        let end = moment(v.end, 'DD-MM-YYYY')
        end.set({hour:0,minute:0,second:0,millisecond:0})
        let realEnd = moment(v.realEnd, 'DD-MM-YYYY')
        realEnd.set({hour:0,minute:0,second:0,millisecond:0})
        let start = moment(v.start, 'DD-MM-YYYY')
        start.set({hour:0,minute:0,second:0,millisecond:0})
        let item = {
          days: v.days,
          realDays: v.realDays,
          discount: v.discount,
          end: end,
          realEnd: realEnd,
          start: start,
          price: v.price,
          status: 1
        }
        room_rates.push(item)
      })

      let check_basic_services_ok = true
      let basic_services_rates = []
      let basic_services_rates_data = this.bookingPaymentData.basic_services_rates.periods
      basic_services_rates_data.forEach(v => {
        if ((v.unit_price == 0) || (v.unit_price == null)) {
          check_basic_services_ok = false
        }
        let end = moment(v.until_date, 'DD-MM-YYYY')
        end.set({hour:0,minute:0,second:0,millisecond:0})
        let item = {
          end: end,
          service: v.service.id,
          old_index: v.old_index.value,
          new_index: v.new_index.value,
          unit_price: utils.formatInteger(v.unit_price.toString()),
          status: 1,
          disable: v.new_index.disable,
          vat: v.vat,
          tax: v.tax,
          removable: v.removable
        }
        basic_services_rates.push(item)
      })

      if (check_basic_services_ok === false) {
        this.validateBasicFee()
        //this.$emit("onClose")
        return
      }

      const saveBookingPayment = {
        apt_booking: this.bookingPaymentData.apt_booking,
        apartment: this.apartment_id,
        payment_code: this.bookingPaymentData.payment_code,
        payment_amount: this.bookingPaymentData.payment_amount,
        payment_amount_vat: this.bookingPaymentData.payment_amount_tax,
        payment_amount_after_vat: this.bookingPaymentData.payment_amount_with_tax,
        payment_left_amount: this.bookingPaymentData.payment_left_amount,
        payment_date: null,
        payment_other_details: this.bookingPaymentData.payment_other_details,
        payment_other_fee: utils.formatInteger(this.bookingPaymentData.payment_other_fee.toString()),
        payment_other_fee_vat: this.bookingPaymentData.payment_other_vat, 
        room_payment_factor: this.bookingPaymentData.room_payment_factor,
        ew_included: this.bookingPaymentData.ew_included,
        discount: utils.formatInteger(this.bookingPaymentData.discount.toString()),
        status: this.bookingPaymentData.status,
        payment_type: this.bookingPaymentData.type,
        room_rates: room_rates,
        basic_services_rates: basic_services_rates,
        services_booking: this.bookingPaymentData.services_booking,
        payment_deposit_option: this.bookingPaymentData.deposit_option,
        payment_export_option: this.bookingPaymentData.payment_export_option,
        return_type: this.bookingPaymentData.returnType,
        payment_checkin:this.bookingPaymentData.payment_checkin,
        payment_checkout: this.bookingPaymentData.payment_checkout
      }
      this.$emit("onAdd", saveBookingPayment, checkout_evt)
    },
    // START - Action phụ thu
    onChangeTotal: function() {
      // Payment other fee
      let payment_other_fee = utils.formatInteger(this.bookingPaymentData.payment_other_fee.toString())
      this.bookingPaymentData.payment_other_fee = utils.formatNumber(payment_other_fee)
      // Discount
      let discount = utils.formatInteger(this.bookingPaymentData.discount.toString())
      this.bookingPaymentData.discount = utils.formatNumber(discount)
      // Payment other tax
      let payment_other_tax = Math.round((payment_other_fee - discount) * this.bookingPaymentData.payment_other_vat / 100)
      this.bookingPaymentData.payment_other_tax = utils.formatNumber(payment_other_tax)
      // Payment other with tax
      let payment_other_fee_with_tax = Number(payment_other_tax) + Number(payment_other_fee - discount)
      this.bookingPaymentData.payment_other_fee_with_tax = utils.formatNumber(payment_other_fee_with_tax)
      this.setTotalBookingPayment()
    },
    // END - Action phụ thu
    // START - Action tổng tiền
    setTotalBookingPayment: function() {
      this.bookingPaymentData.payment_amount = 0
      this.bookingPaymentData.payment_amount_tax = 0
      this.bookingPaymentData.payment_amount_with_tax = 0
      
      let room_rates_total = this.bookingPaymentData.returnType === 1 ? parseInt(this.bookingPaymentData.room_rates.total) : parseInt(this.bookingPaymentData.room_rates.realTotal)
      let room_rates_tax = this.bookingPaymentData.returnType === 1 ? parseInt(this.bookingPaymentData.room_rates.tax) : parseInt(this.bookingPaymentData.room_rates.realTax)
      let basic_services_rates_total = parseInt(this.bookingPaymentData.basic_services_rates.total)
      let basic_services_rates_tax = parseInt(this.bookingPaymentData.basic_services_rates.tax)
      let payment_other_fee = parseInt(utils.formatInteger(this.bookingPaymentData.payment_other_fee.toString()))
      let payment_other_fee_tax = parseInt(utils.formatInteger(this.bookingPaymentData.payment_other_tax.toString()))
      // let discount = this.bookingPaymentData.discount ? parseInt(this.bookingPaymentData.discount) : 0
      // Payment amount
      this.bookingPaymentData.payment_amount = Math.round(room_rates_total + basic_services_rates_total + payment_other_fee)
      // Payment amount tax
      this.bookingPaymentData.payment_amount_tax = Math.round(room_rates_tax + basic_services_rates_tax + payment_other_fee_tax)
      // Total Payment amount with tax
      this.bookingPaymentData.payment_amount_with_tax = this.bookingPaymentData.payment_amount + this.bookingPaymentData.payment_amount_tax
      this.bookingPaymentData.payment_left_amount = this.bookingPaymentData.payment_amount_with_tax
    },
    // END - Action tổng tiền
    // START - Những action liên quan dịch vụ điện nước
    onChangeBasicService: function() {
      if (this.bookingPaymentData.ew_included === true) {
        this.bookingPaymentData.basic_services_rates.total = 0
        this.bookingPaymentData.basic_services_rates.tax = 0
        this.bookingPaymentData.basic_services_rates.total_with_tax = 0
      } else {
        const {total, tax, total_with_tax} = this.getTotalBasicServiceRate()
        this.bookingPaymentData.basic_services_rates.total = total
        this.bookingPaymentData.basic_services_rates.tax = tax
        this.bookingPaymentData.basic_services_rates.total_with_tax = total_with_tax
      }
      this.setTotalBookingPayment()
    },
    getTotalBasicServiceRate: function() {
      let total = 0
      let tax = 0
      let total_with_tax = 0
      this.bookingPaymentData.basic_services_rates.periods.forEach(v => {
        total += v['price']
        tax += v['tax']
      })
      total_with_tax = total + tax
      return {
        total: total,
        tax: tax,
        total_with_tax: total_with_tax
      }
    },
    onRemoveBasicServices: function(item, index) {
      this.bookingPaymentData.basic_services_rates.periods.splice(index, 1)
      let filter_basic_service_rates = this.bookingPaymentData.basic_services_rates.periods.filter(v=> {return v['service']['id'] ===  item.service.id})
      let last_service_rate = null
      if (filter_basic_service_rates.length > 0){
        last_service_rate = filter_basic_service_rates[filter_basic_service_rates.length - 1]
        last_service_rate['new_index']['disable'] = false
        last_service_rate['removable'] = true
      }
      const {total, tax, total_with_tax} = this.getTotalBasicServiceRate()
      this.bookingPaymentData.basic_services_rates.total = total
      this.bookingPaymentData.basic_services_rates.tax = tax
      this.bookingPaymentData.basic_services_rates.total_with_tax = total_with_tax
      this.setTotalBookingPayment()
    },
    onChangeUnitPrice: function (item) {
      let unit_price = 0
      if (!utils.isNull(item['unit_price'])) {
        unit_price = utils.formatInteger(item['unit_price'].toString())
      }
      item['tax'] = Math.round((item['consumption'] * unit_price) * item['vat'] / 100)
      item['price'] = Math.round(item['consumption'] * unit_price)
      item['unit_price'] = utils.formatNumber(unit_price)
      item['price_with_tax'] = item['tax'] + item['price']
      const {total, tax, total_with_tax} = this.getTotalBasicServiceRate()
      this.bookingPaymentData.basic_services_rates.total = total
      this.bookingPaymentData.basic_services_rates.tax = tax
      this.bookingPaymentData.basic_services_rates.total_with_tax = total_with_tax
      this.setTotalBookingPayment()
    },
    onChangeVat: function (item) {
      let unit_price = 0
      if (!utils.isNull(item['unit_price'])) {
        unit_price = utils.formatInteger(item['unit_price'].toString())
      }
      item['tax'] = Math.round((item['consumption'] * unit_price) * item['vat'] / 100)
      item['price'] = Math.round(item['consumption'] * unit_price)
      item['price_with_tax'] = item['tax'] + item['price']
      const {total, tax, total_with_tax} = this.getTotalBasicServiceRate()
      this.bookingPaymentData.basic_services_rates.total = total
      this.bookingPaymentData.basic_services_rates.tax = tax
      this.bookingPaymentData.basic_services_rates.total_with_tax = total_with_tax
      this.setTotalBookingPayment()
    },
    onChangeNewIndex: function (item) {
      let unit_price = 0
      if (!utils.isNull(item['unit_price'])) {
        unit_price = utils.formatInteger(item['unit_price'].toString())
      }
      item['tax'] = Math.round((item['consumption'] * unit_price) * item['vat'] / 100)
      item['consumption'] = parseInt(item['new_index']['value']) - item['old_index']['value']
      item['price'] = Math.round(item['consumption'] * unit_price)
      item['price_with_tax'] = item['tax'] + item['price']
      const {total, tax, total_with_tax} = this.getTotalBasicServiceRate()
      this.bookingPaymentData.basic_services_rates.total = total
      this.bookingPaymentData.basic_services_rates.tax = tax
      this.bookingPaymentData.basic_services_rates.total_with_tax = total_with_tax
      this.setTotalBookingPayment()
    },
    onAddBasicService: function () {
      let service, new_index, old_index
      let last_service_rate = null
      let filter_basic_service_rates = this.bookingPaymentData.basic_services_rates.periods.filter(v=> {return v['service']['id'] ===  this.basicServices.selectedService})
      if (filter_basic_service_rates.length > 0){
        last_service_rate = filter_basic_service_rates[filter_basic_service_rates.length - 1]
      }
      if (this.basicServices.selectedService === 1) {
        // điện
        service = {
          id: this.basicServices.selectedService,
          name: "electric"
        }

        if (last_service_rate === null) {
          old_index = this.bookingData.start_e
        } else {
          old_index = last_service_rate['new_index']['value']
          last_service_rate['new_index']['disable'] = true
          last_service_rate['removable'] = false
        }
        
      } else if (this.basicServices.selectedService === 2) {
        // nước
        service = {
          id: this.basicServices.selectedService,
          name: "water"
        }
        
        if (last_service_rate === null) {
          old_index = this.bookingData.start_w
        } else {
          old_index = last_service_rate['new_index']['value']
          last_service_rate['new_index']['disable'] = true
          last_service_rate['removable'] = false
        }
        
      }
      new_index = old_index
      let item = {
        service: service,
        until_date: new Date(),
        old_index: {
          value: old_index,
          disable: true
        },
        new_index: {
          value: new_index,
          disable: false
        },
        consumption: new_index - old_index,
        unit_price: this.basicServices.selectedService === 1 ? this.e_unit_price : (this.basicServices.selectedService === 2 ? this.w_unit_price : 0),
        price: 0,
        vat: 0,
        tax: 0,
        removable: true
      }
      this.bookingPaymentData.basic_services_rates.periods.push(item)
      const {total, tax, total_with_tax} = this.getTotalBasicServiceRate()
      this.bookingPaymentData.basic_services_rates.total = total
      this.bookingPaymentData.basic_services_rates.tax = tax
      this.bookingPaymentData.basic_services_rates.total_with_tax = total_with_tax
      this.setTotalBookingPayment()
    },
    // END - Những action liên quan dịch vụ điện nước
    getTotal: function(num_of_days) {
      let booking_room_rate = this.bookingData.apartment_map_booking.booking_room_rate
      let sale_off = this.bookingData.sale_off
      //let month = parseInt(num_of_days / 30)
      //let day =  num_of_days % 30
      let booking_room_rate_discount = booking_room_rate * (1 - sale_off / 100)
      //let package_summary = (booking_room_rate_discount * month) + (booking_room_rate_discount / (this.bookingPaymentData.room_payment_factor == 1 ? 30 : (this.bookingPaymentData.room_payment_factor == 2 ? 7 : 1)) * day)
      let package_summary = (booking_room_rate_discount / (this.bookingPaymentData.room_payment_factor == 1 ? 30 : (this.bookingPaymentData.room_payment_factor == 2 ? 7 : 1)) * num_of_days)
      return package_summary
    },
    // iterateInstallment1: function (date2, date1, daily_room_rate) {
    //   // [Khanh]: keeping for backup
    //   let start = moment(date1)
    //   let end = moment(date2)
    //   let result = {
    //     total: 0,
    //     periods: []
    //   }
    //   while (start.isBefore(end)) {
    //     let item = {}
    //     let days = end.diff(start, 'days')
    //     item['start'] = start.format(this.options.format)
    //     start.add(1, 'month')
    //     if (start.isSameOrAfter(end)) {
    //       item['end'] = end.format(this.options.format)
    //     } else {
    //       item['end'] = start.format(this.options.format)
    //       days = 30
    //     }
    //     item['days'] = days
    //     item['price'] = days * daily_room_rate
    //     result.total += item['price']
    //     result.periods.push(item)
    //   }
    //   return result
    // },
    iterateInstallment2: function (date2, date1) {
      let start = moment(date1)
      // Because get real checkout so change end date from checkout to current date
      let end = moment(date2)
      // Real end for new flow
      let realEnd = moment(new Date())
      let result = {
        total: 0,
        realTotal: 0,
        tax: 0,
        realTax: 0,
        total_with_tax: 0,
        real_total_with_tax: 0,
        periods: [],
        // Real periods for new flow
        realPeriods: []
      }
      let item = {}

      let start_bk = moment(start)
      let days
      // Real days
      let realDays
      item['start'] = start.format(this.options.format)
      item['end'] = end.format(this.options.format)
      // Real end
      item['realEnd'] = realEnd.format(this.options.format)
      item['discount'] = this.bookingData.discount
      days = end.diff(start_bk, 'days')
      realDays = realEnd.diff(start_bk, 'days')
      if (realDays == 0 || realDays == '0') {
          realDays = 1
      }
      item['days'] = days
      // Real days
      item['realDays'] = realDays
      let totalPrice = this.getTotal(days)
      let realTotalPrice = this.getTotal(realDays)
      item['price'] = Math.round(totalPrice)
      // Real price
      item['realPrice'] = Math.round(realTotalPrice)
      item['price_with_tax'] = Math.round((item['price'] - item['discount']) * this.bookingData.apartment_map_booking.booking_room_rate_vat / 100)
      // Real price with tax
      item['real_price_with_tax'] = Math.round((item['realPrice'] - item['discount']) * this.bookingData.apartment_map_booking.booking_room_rate_vat / 100)
      result.total += item['price'] - item['discount']
      result.realTotal += item['realPrice'] - item['discount']
      result.tax += item['price_with_tax']
      result.realTax += item['real_price_with_tax']
      result.periods.push(item)
      result.realPeriods.push(item)

      result.total_with_tax = result.total + result.tax
      result.real_total_with_tax = result.realTotal + result.realTax
      return result
    },
    // iterateInstallment3: function (date2, date1) {
    //   let start = moment(date1)
    //   // Because get real checkout so change end date from checkout to current date
    //   let end = moment(date2)
    //   // Real end for new flow
    //   let realEnd = moment(new Date())
    //   // let sale_off_amount = utils.makeRoundNumber((daily_room_rate*sale_off)/100)
    //   // let daily_room_rate_after_sale_off = daily_room_rate - sale_off_amount
    //   let result = {
    //     total: 0,
    //     tax: 0,
    //     total_with_tax: 0,
    //     periods: [],
    //     // Real periods for new flow
    //     realPeriods: []
    //   }
    //   while (start.isBefore(end)) {
    //     let item = {}
    //     let start_bk = moment(start)
    //     let days
    //     // Real days
    //     let realDays
    //     item['start'] = start.format(this.options.format)
    //     start.add(1, 'month')
    //     if (start.isSameOrAfter(end)) {
    //       item['end'] = end.format(this.options.format)
    //       // Real end
    //       item['realEnd'] = realEnd.format(this.options.format)
    //       item['discount'] = this.bookingData.discount
    //       days = end.diff(start_bk, 'days')
    //       realDays = realEnd.diff(start_bk, 'days')
    //     } else {
    //       // Real end
    //       item['realEnd'] = start.format(this.options.format)
    //       item['end'] = start.format(this.options.format)
    //       item['discount'] = 0
    //       days = start.diff(start_bk, 'days')
    //       // Real days
    //       realDays = start.diff(start_bk, 'days')
    //     }
    //     if (realDays == 0 || realDays == '0') {
    //       realDays = 1
    //     }
    //     item['days'] = days
    //     // Real days
    //     item['realDays'] = realDays
    //     let totalPrice = this.getTotal(days)
    //     let realTotalPrice = this.getTotal(realDays)
    //     item['price'] = Math.round(totalPrice)
    //     // Real price
    //     item['realPrice'] = Math.round(realTotalPrice)
    //     item['price_with_tax'] = Math.round((item['price'] - item['discount']) * this.bookingData.apartment_map_booking.booking_room_rate_vat / 100)
    //     // Real price with tax
    //     item['real_price_with_tax'] = Math.round((item['realPrice'] - item['discount']) * this.bookingData.apartment_map_booking.booking_room_rate_vat / 100)
    //     result.total += item['price'] - item['discount']
    //     result.tax += item['price_with_tax']
    //     result.periods.push(item)
    //     result.realPeriods.push(item)
    //   }
    //   result.total_with_tax = result.total + result.tax
    //   return result
    // },
    formatNumber: function (n) {
      if ((n !== null) || (n !== 0)) {
        return utils.formatNumber(n)
      }
      return 0
    },
    formatDate: function (d) {
      return utils.formatSqlDate(d, null, this.options.format)
    },
    onCheckOut: function(){
      let checkout_evt = true
      if (this.bookingPaymentData.id !== 0) {
        this.onSave(null, checkout_evt)
      } else {
        this.onAdd(null, checkout_evt)
      }
    },
    checkOut: function() {
      let booking_id = this.bookingPaymentData.apt_booking
      if (booking_id != 0) {
        this.CHECKOUT_APARTMENT_BOOKING({id: booking_id}).then(
          function(res) {
            this.SUCCESS_TOAST()
            $(this.$refs['modal-confirm']).modal("hide");
            this.$emit("onCheckout")
          }.bind(this)
        ).catch(
          function(error) {
            let error_code = error.response.data.error_code
            if (error_code == 'is_checked_out' ) {
              this.ON_SHOW_TOAST({
                message: "Bạn đã trả phòng.",
                styleType: "danger"
              })
              $(this.$refs['modal-confirm']).modal("hide");
              this.$emit("onCheckout")
            } else {
              this.ERROR_TOAST()
            }
          }.bind(this)
        )
      } else {
        this.ON_SHOW_TOAST({
          message: 'Có lỗi xảy ra vui lòng thử lại',
          styleType: "danger"
        })
      }
    },
    create() {
      const projectId = utils.getProjectSession()
      this.GET_PROJECT_DETAIL({ id: projectId }).then(
        function(res) {
          let projData = res.data
          this.e_unit_price = projData.sa_default_e_fee
          this.w_unit_price = projData.sa_default_w_fee
        }.bind(this)
      );
      if ( ('booking_id' in this.item) || ('apartment_id' in this.item) ) {
        // mandatory keys required
        this.bookingData.id = this.item.booking_id
        this.apartment_id = this.item.apartment_id
        if (this.bookingData.id === 0 || this.apartment_id === 0) {return}
        const booking_data = {
          id: this.bookingData.id,
          params: {
            apartment: this.apartment_id
          }
        }
        this.GET_BOOKING_APARTMENT_DETAIL(booking_data).then(
          function (res) {
            let data = res
            // apartment data
            this.apartment_data.apartment_code = data.apartment_map_booking.apartment_details.apartment_code
            this.bookingData.start_e = data.apartment_map_booking.start_e
            this.bookingData.start_w = data.apartment_map_booking.start_w
            // booking data
            this.bookingData.id = data.id
            this.bookingData.checkin_datetime = data.checkin_datetime
            this.bookingData.checkout_datetime = data.checkout_datetime
            // DURATION - #1131 Thếm Số Ngày
            let duration = this.getDaysDiff(data.checkout_datetime, data.checkin_datetime, false)
            this.bookingData.duration = duration
            this.bookingData.booking_person_name = data.booking_person_name

            this.bookingData.apartment_map_booking.booking_room_rate = data.apartment_map_booking.booking_room_rate
            this.bookingData.apartment_map_booking.booking_room_rate_daily = data.apartment_map_booking.booking_room_rate_daily
            this.bookingData.apartment_map_booking.booking_room_rate_vat = data.apartment_map_booking.booking_room_rate_vat
            this.bookingData.sale_off = data.sale_off
            this.bookingData.discount = data.discount
            this.bookingData.ew_included = data.ew_included
            this.bookingData.apartment_map_booking.other_fee = data.apartment_map_booking.other_fee
            this.bookingData.apartment_map_booking.other_vat = data.apartment_map_booking.other_vat
            this.bookingData.apartment_map_booking.other_details = data.apartment_map_booking.other_details
            this.bookingData.apartment_map_booking.payment_duration_factor = data.apartment_map_booking.payment_duration_factor
            this.bookingData.services_booking = data.services_booking
            this.bookingData.booking_payment = data.booking_payment
            this.bookingData.deposit = data.deposit
            this.bookingData.payment_in_advance = data.payment_in_advance

            // [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN
            this.bookingData.company_name = data.company_name
            this.bookingData.company_address = data.company_address
            this.bookingData.company_tax_code = data.company_tax_code
            this.bookingData.company_email = data.company_email

            // booking payment data
            this.bookingPaymentData.id = this.bookingData.booking_payment

            if (this.bookingPaymentData.id === 0) {
              this.bookingPaymentData.apt_booking = this.bookingData.id
              this.bookingPaymentData.room_payment_factor = this.bookingData.apartment_map_booking.payment_duration_factor
              let installment_data2 = this.iterateInstallment2(this.bookingData.checkout_datetime, this.bookingData.checkin_datetime)
              this.bookingPaymentData.room_rates = installment_data2
              this.bookingPaymentData.ew_included = this.bookingData.ew_included
              this.bookingPaymentData.payment_other_fee = utils.formatNumber(this.bookingData.apartment_map_booking.other_fee)
              this.bookingPaymentData.payment_other_vat = this.bookingData.apartment_map_booking.other_vat
              this.bookingPaymentData.payment_other_tax = utils.formatNumber(Math.round(this.bookingData.apartment_map_booking.other_fee * this.bookingData.apartment_map_booking.other_vat / 100))
              this.bookingPaymentData.payment_other_fee_with_tax = utils.formatNumber(this.bookingData.apartment_map_booking.other_fee + Number(utils.formatInteger(this.bookingPaymentData.payment_other_tax.toString())))
              this.bookingPaymentData.payment_other_details = this.bookingData.apartment_map_booking.other_details
              this.bookingPaymentData.payment_checkin = this.bookingData.checkin_datetime
              this.bookingPaymentData.payment_checkout = new Date()
              let pm_duration = this.getDaysDiff(this.bookingPaymentData.payment_checkout, this.bookingPaymentData.payment_checkin, false)
              this.bookingPaymentData.duration = pm_duration
              // total
              this.setTotalBookingPayment()
            } else {
              this.GET_BOOKING_PAYMENT_DETAILS({id: this.bookingPaymentData.id}).then(
                function(res){
                  let res_data = res
                  this.bookingPaymentData.payment_export_option = res_data.payment_export_option
                  this.bookingPaymentData.deposit_option = res_data.payment_deposit_option
                  this.bookingPaymentData.status = res_data.status
                  this.bookingPaymentData.type = res_data.payment_type
                  this.bookingPaymentData.apt_booking = res_data.apt_booking
                  this.bookingPaymentData.apartment = res_data.apartment
                  this.bookingPaymentData.room_payment_factor = res_data.room_payment_factor
                  this.bookingPaymentData.ew_included = res_data.ew_included
                  this.bookingPaymentData.payment_other_fee = utils.formatNumber(res_data.payment_other_fee)
                  this.bookingPaymentData.payment_other_vat = res_data.payment_other_fee_vat
                  this.bookingPaymentData.payment_other_tax = utils.formatNumber(Math.round(res_data.payment_other_fee * res_data.payment_other_fee_vat / 100))
                  this.bookingPaymentData.payment_other_fee_with_tax = utils.formatNumber(res_data.payment_other_fee + Math.round(res_data.payment_other_fee * res_data.payment_other_fee_vat / 100))
                  this.bookingPaymentData.payment_other_details = res_data.payment_other_details
                  this.bookingPaymentData.payment_amount = res_data.payment_amount
                  this.bookingPaymentData.payment_amount_tax = res_data.payment_amount_vat
                  this.bookingPaymentData.payment_amount_with_tax = res_data.payment_amount_after_vat
                  this.bookingPaymentData.payment_left_amount = res_data.payment_left_amount
                  this.bookingPaymentData.payment_code = res_data.payment_code
                  this.bookingPaymentData.discount = utils.formatInteger(res_data.discount.toString())
                  this.bookingPaymentData.payment_checkin = res_data.payment_checkin ? res_data.payment_checkin : this.bookingData.checkin_datetime
                  this.bookingPaymentData.payment_checkout = res_data.payment_checkout ? res_data.payment_checkout : new Date()
                  let pm_duration = this.getDaysDiff(this.bookingPaymentData.payment_checkout, this.bookingPaymentData.payment_checkin, false)
                  this.bookingPaymentData.duration = pm_duration
                  this.bookingPaymentData.returnType = res_data.return_type
                  this.user_created = res_data.user_created_details ? `${res_data.user_created_details.last_name} ${res_data.user_created_details.first_name}` : null
                  
                  // Room rates
                  let room_rates = {
                    total: 0,
                    realTotal: 0,
                    tax: 0,
                    realTax: 0,
                    total_with_tax: 0,
                    real_total_with_tax: 0,
                    periods: [],
                    // Real periods for new flow
                    realPeriods: []
                  }
                  res_data.room_rates.forEach(v => {
                    let item = {
                      start: utils.formatSqlDate(v.start, null, this.options.format),
                      end: utils.formatSqlDate(v.end, null, this.options.format),
                      realEnd: utils.formatSqlDate(v.realEnd, null, this.options.format),
                      days: v.days,
                      realDays: v.realDays,
                      discount: v.discount,
                      price: v.price
                    }

                    //let totalPrice = this.getTotal(item.days)
                    let realTotalPrice = this.getTotal(item.realDays)
                    item['realPrice'] = Math.round(realTotalPrice)
                    item['price_with_tax'] = Math.round((item['price'] - item['discount']) * this.bookingData.apartment_map_booking.booking_room_rate_vat / 100)
                    // Real price with tax
                    item['real_price_with_tax'] = Math.round((item['realPrice'] - item['discount']) * this.bookingData.apartment_map_booking.booking_room_rate_vat / 100)
                    //item['price_with_tax'] = Math.round((item['price'] - item['discount']) * this.bookingData.apartment_map_booking.booking_room_rate_vat / 100)
                    room_rates.total += item['price'] - item['discount']
                    room_rates.realTotal += item['realPrice'] - item['discount']
                    room_rates.tax += item['price_with_tax']
                    room_rates.realTax += item['real_price_with_tax']
                    room_rates.periods.push(item)
                    room_rates.realPeriods.push(item)
                  })
                  room_rates.total_with_tax = room_rates.total + room_rates.tax
                  room_rates.real_total_with_tax = room_rates.realTotal + room_rates.realTax
                  // Điện, nước
                  let basic_services_rates = {
                    total: 0,
                    periods: [],
                    tax: 0,
                    total_with_tax: 0
                  }
                  res_data.basic_services_rates.forEach(v => {
                    let service_name = "electric"
                    if (v.service === 2) {
                      service_name = "water"
                    }
                    let service = {
                      id: v.service,
                      name: service_name
                    }
                    let element = {
                      service: service,
                      until_date: utils.formatSqlDate(v.end, null, this.options.format),
                      old_index: {
                        value: v.old_index,
                        disable: true
                      },
                      new_index: {
                        value: v.new_index,
                        disable: v.disable
                      },
                      consumption: v.new_index - v.old_index,
                      unit_price: v.unit_price,
                      price: v.unit_price * (v.new_index - v.old_index),
                      vat: v.vat,
                      tax: v.tax,
                      removable: v.removable
                    }
                    basic_services_rates.periods.push(element)
                    basic_services_rates.total += element['price']
                    basic_services_rates.tax += element['tax']
                  })
                  basic_services_rates.total_with_tax = basic_services_rates.total + basic_services_rates.tax

                  this.bookingPaymentData.room_rates = room_rates
                  this.bookingPaymentData.basic_services_rates = basic_services_rates
                }.bind(this)
              )
            }
            
            this.bookingPaymentData.services_booking = this.bookingData.services_booking

            // this.bookingPaymentData.room_rates.total = Math.round(this.bookingPaymentData.room_rates.total) + this.bookingData.discount

            

          }.bind(this)
        )
      }
    },
    ...mapActions([
      // "GET_BOOKING_DETAIL",
      "GET_BOOKING_APARTMENT_DETAIL",
      "CHECKOUT_APARTMENT_BOOKING",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_PROJECT_DETAIL"
    ]),
    ...mapActions("bookingModule", [
      // "ADD_BOOKING_PAYMENT",
      // "GET_SERVICES_BOOKING",
      "GET_BOOKING_PAYMENT_DETAILS"
    ]),
  },
  components: {
    "date-picker": datePicker,
  },
  mounted() {
    this.create()
  }
};
</script>

<style scoped>
.service-container {
  max-height: 400px;
  overflow: auto;
}

.section-header {
  margin: 10px 0 20px 0;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}

.page-header {
  margin: 10px 0 20px 0;
  font-size: 16px;
  border-bottom: none;
}

.small-title {
  color: #666;
  display: block;
  margin-top: 5px;
  font-size: 14px;
}

.inline {
  display: inline
}

.hr {
  border-top: 1px solid #eee;
  margin-top: 0px;
  margin-bottom: 20px;
}

.customer-info {
  margin-top: -15px;
}

.customer-info .table>tbody>tr>th, .table>tbody>tr>td {
  padding: 1px;
  border-top: none;
}

.basic-input {
  /* width: 50%; */
  height: 25px;
}

.modal {
  text-align: center;
}

@media screen and (min-width: 768px) { 
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

/* use for print not apply score */
@media screen {
  #printSection {
      display: none;
  }
}

@media print {
  body * {
    visibility:hidden ;
  }
  #printSection, #printSection * {
    visibility:visible;
  }

  /* hidden print-pdf-footer */
  #printSection, #print-pdf-footer * {
    visibility:hidden;
  }
  
  #printSection {
    position:absolute;
    left:0;
    top:10px;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackBookingPayment.vue